import { render, staticRenderFns } from "./LgFinderPageTipoAquisicao.vue?vue&type=template&id=745b633d"
import script from "./LgFinderPageTipoAquisicao.vue?vue&type=script&lang=js"
export * from "./LgFinderPageTipoAquisicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports